import { GameScene, IGameState } from '../../../State/Game/IGameState';
import { TActionType, TGameArea, TransactionType } from '../DataSet/Transaction';
import { sendEvent, track } from '../Track';
import { TransactionTrackingEventName } from '../TrackingEvent';
import { UICrumbType } from '../../../State/UI/UICrumb';

export function trackTransaction(
    state: IGameState,
    transactionType: TransactionType,
    tActionType: TActionType
) {
    track('transactionType', transactionType);
    track('tActionType', tActionType);
    track('tLevelContext', state.levelState.levelNumber);
    track('tLevelTypeContext', "saga");
    track('tGameArea', getGameArea(state));

    if (state.activeScene.result !== GameScene.LEVEL) {
        sendEvent(TransactionTrackingEventName.resource, state);
    }
}

/**
 * Tracking for Transaction and the Resources gotten out of it
 * @param state
 * @param transactionType
 * @param tActionType
 * @constructor
 */
export function trackStatePurchase(
    state: IGameState,
    transactionType: TransactionType,
    tActionType: TActionType
) {
    track('transactionType', transactionType);
    track('tGameArea', getGameArea(state));
    track('tActionType', tActionType);
    track('tLevelContext', state.levelState.levelNumber);
    track('tLevelTypeContext', "saga");
    sendEvent(TransactionTrackingEventName.transaction, state);
    if (state.activeScene.result !== GameScene.LEVEL) {
        sendEvent(TransactionTrackingEventName.resource, state);
    }
}

/**
 * Tracking for Transaction Event
 * @param productPrice: price of the product bought
 * @param productCurrencyType: currency type, for example USD = us dollar
 */
export function trackPurchasedProduct(
    productPrice: number,
    productCurrencyType: string
) {
    if (productPrice) {
        track('productsSpent', {
            realCurrency: {
                realCurrencyAmount: productPrice,
                realCurrencyType: productCurrencyType,
            },
        });
    } else {
        track('productsSpent', {
            realCurrency: {
                realCurrencyAmount: 0,
                realCurrencyType: productCurrencyType,
            },
        });
    }
}

/**
 * Get the current 'game area' (according to DDNA) from the game state.
 * @param state
 */
function getGameArea(state: IGameState) {
    if (state.activeScene) {
        if (state.activeScene.result === GameScene.LEVEL) {
            return TGameArea.LEVEL;
        }

        if (state.UIState && state.UIState.crumb) {
            if (
                state.UIState.crumb.type === UICrumbType.SOCIAL_FRIENDS ||
                state.UIState.crumb.type === UICrumbType.SOCIAL_LIVES
            ) {
                return TGameArea.SOCIAL_SCREEN;
            }

            if (state.UIState.crumb.type === UICrumbType.MISSIONS) {
                return TGameArea.EVENT_SCREEN;
            }
        }
    }

    return TGameArea.MAP;
}
